import Image from "next/image";
import React from "react";
import styles from "./Section9.module.scss";

export const Section9 = function () {
  return (
    <section id="usp" className={`${styles.container} cc--component-container`}>
      <section className={styles.content}>
        <h3 className={styles.headline}>An Online Education That Sets You Apart</h3>
        <span className={styles.subHeadline}>
          This online short course from Harvard’s VPAL and HarvardX is delivered in collaboration with online education
          provider, GetSmarter. Join a growing community of global professionals who have already benefited from the
          opportunity to:
        </span>
        <section className={styles.props}>
          <div className={styles.prop}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/02/d63dd542-icons-harvard-support_028028028028000000001.png"
              alt=""
              height={80}
              width={80}
            />
            <span>
              Develop relevant, sought-after skills and earn invaluable recognition{" "}
              <strong>from an international selection of universities</strong>, entirely online
            </span>
          </div>
          <div className={styles.prop}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/02/75d5bc89-icons-harvard-grad_02i02i02i02i000000001.png"
              alt=""
              height={80}
              width={80}
            />
            <span>
              Enjoy a <strong>personalized, people-mediated</strong> online learning experience created to make you feel
              supported at every step
            </span>
          </div>
          <div className={styles.prop}>
            <Image
              src="https://www.getsmarter.com/presentations/wp-content/uploads/2019/02/9145041b-icons-harvard-certi_029029029029000000001.png"
              alt=""
              height={80}
              width={80}
            />
            <span>
              Gain <strong>verifiable and relevant competencies</strong> through a career-focused curriculum that
              achieves specific learning outcomes and skill gains
            </span>
          </div>
        </section>
      </section>
    </section>
  );
};
